import api from '@/services/api/api';
import Api from '@/services/Api';
import store from '@/store'

const initialState = () => ({
  authenticated: false,
  user: { certificates: [] },
  exam: null
});

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    user: (state) => state.user
  },
  mutations: {
    setSession(state, payload) {
      state.authenticated = true;
      state.user = { ...state.user, ...payload.data };
      state.exam = payload.exam;
    },
    logout(state) {
      Object.assign(state, initialState());
    },
    setCertificates(state, payload) {
      state.user.certificates = payload;
    },
  },
  actions: {
    // eslint-disable-next-line
    async recaptcha(_, action) {
      return new Promise((res) => {
        // eslint-disable-next-line
        grecaptcha.ready(() => {
          // eslint-disable-next-line
          grecaptcha
            .execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action })
            .then((token) => res(token));
        });
      });
    },
    async isAuthenticated({ state, commit }) {
      if(state.authenticated){
        return true;
      }

      if(!store.state.AuthFirebase.auth.currentUser){
        return false;
      }

      try {
        const { data } = await api.get('/auth/session');
        commit('setSession', data);
      } catch (err) {
        commit('logout');
        return false;
      }

      await store.dispatch('Init/fetchUserCalendars');
      return true;
    },
    async logout({ commit }) {
      try {
        await api.get('/auth/logout');
      } catch (err) {
        console.log(err);
      }
      commit('logout');
    },
    async fetchCertificates({ commit }, contactoId) {
      try {
        const { data } = await Api.get(`/contactos/${contactoId}/certificados`);
        const certificates = data.data;
        if (certificates.length) commit('setCertificates', certificates);
      } catch (err) {
        commit('setCertificates', []);
      }
    },
    async flushSession() {
      try {
        await api.post('/session/flush/me');
      } catch (err) {
        console.log(err);
      }
    },
  },
};
